"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decorators = void 0;
var decorators_1 = require("../decorators");
exports.decorators = [decorators_1.withLaunchDarkly];
//# sourceMappingURL=addDecorator.js.map